import { AxiosError } from 'axios';
import { fetcher, getRequestConfig, UnauthorizedError } from './fetcher';

const Paths = {
  APPLICATIONS: '/user/applications',
};

export enum ApplicationStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export type Application = {
  applicationId: string;
  createdAt: string;
  status: ApplicationStatus;
};

export type Applications = {
  applications?: {
    AUTO?: Application;
    HOME?: Application;
  };
};

const getApplicationStatus = async (): Promise<Applications> => {
  try {
    const response = await fetcher.get(Paths.APPLICATIONS, getRequestConfig());

    return response.data;
  } catch (error) {
    if ((error as AxiosError)?.response?.status === 401) {
      throw new UnauthorizedError((error as AxiosError)?.message);
    }

    throw new Error(`Could not verify status - ${error}`);
  }
};

export { getApplicationStatus };
